import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'sq',
  months: [
    'janar',
    'shkurt',
    'mars',
    'prill',
    'maj',
    'qershor',
    'korrik',
    'gusht',
    'shtator',
    'tetor',
    'nëntor',
    'dhjetor',
  ],
  monthsShort: ['jan', 'shk', 'mar', 'pri', 'maj', 'qer', 'korr', 'gush', 'sht', 'tet', 'nën', 'dhj'],
  weekdays: ['e diel', 'e hënë', 'e martë', 'e mërkurë', 'e enjte', 'e premte', 'e shtunë'],
  weekdaysMin: ['d', 'h', 'm', 'm', 'e', 'p', 'sh'],
  weekdaysShort: ['Die', 'Hën', 'Mar', 'Mër', 'Enj', 'Pre', 'Sht'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D.M.YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY, HH:mm',
    'LLL-Y': 'D MMMM, HH:mm',
    LLLL: 'dddd, D MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd D MMMM, HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY, h:mm A',
    'lll-Y': 'D MMM, h:mm A',
    llll: 'ddd, D MMM YYYY, h:mm A',
    'llll-Y': 'ddd, D MMM, h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'p.d.', pm: 'm.d.', AM: 'p.d.', PM: 'm.d.' },
  past: {
    y: { one: '%s vit më parë', other: '%s vjet më parë' },
    M: { one: '%s muaj më parë', other: '%s muaj më parë' },
    w: { one: '%s javë më parë', other: '%s javë më parë' },
    d: { one: '%s ditë më parë', other: '%s ditë më parë' },
    h: { one: '%s orë më parë', other: '%s orë më parë' },
    m: { one: '%s min më parë', other: '%s min më parë' },
    s: { one: '%s sek më parë', other: '%s sek më parë' },
  },
  future: {
    y: { one: 'pas %s viti', other: 'pas %s vjetësh' },
    M: { one: 'pas %s muaji', other: 'pas %s muajsh' },
    w: { one: 'pas %s jave', other: 'pas %s javësh' },
    d: { one: 'pas %s dite', other: 'pas %s ditësh' },
    h: { one: 'pas %s ore', other: 'pas %s orësh' },
    m: { one: 'pas %s min', other: 'pas %s min' },
    s: { one: 'pas %s sek', other: 'pas %s sek' },
  },
  abbr: {
    y: { one: '%s vit', other: '%s vjet' },
    M: { one: '%s muaj', other: '%s muaj' },
    w: { one: '%s javë', other: '%s javë' },
    d: { one: '%s ditë', other: '%s ditë' },
    h: { one: '%s orë', other: '%s orë' },
    m: { one: '%s min.', other: '%s min.' },
    s: { one: '%s sek.', other: '%s sek.' },
  },
  justNow: 'tani',
  yesterday: 'dje',
  today: 'sot',
  tomorrow: 'nesër',
  weekStart: 1,
};
const localeName: LocaleName = 'sq';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'p.d.' : 'p.d.';
    } else {
      return isLowerCase ? 'm.d.' : 'm.d.';
    }
  },
};
